import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import taskApi from "../api/task";
import checklistTaskApi from "../api/checklistTask";

export const fetchTasks = createAsyncThunk(
  "tasks/fetchTasksStatus",
  async () => {
    return await taskApi.all();
  }
);

export const markTaskAsDone = createAsyncThunk(
  "tasks/markTaskAsDoneStatus",
  async ({ id }) => {
    return await taskApi.markAsDone(id);
  }
);

export const changeModule = createAsyncThunk(
  "tasks/changeModuleStatus",
  async ({ task, moduleIndex }) => {
    return await taskApi.nextModule(task.id, moduleIndex);
  }
);

export const startTask = createAsyncThunk(
  "tasks/startTaskStatus",
  async ({ id }) => {
    return await taskApi.startTask(id);
  }
);

export const restartTask = createAsyncThunk(
  "tasks/restartTaskStatus",
  async ({ id }) => {
    return await taskApi.restartTask(id);
  }
);

export const toggleChecklistItemOfTask = createAsyncThunk(
  "tasks/toggleChecklistItemOfTaskStatus",
  async ({ task, itemId, value }) => {
    return await checklistTaskApi.toggleState(task.id, itemId, value);
  }
);

export const selectResult = createAsyncThunk(
  "tasks/selectResultStatus",
  async ({ task, result }) => {
    return await taskApi.selectResult(task.id, result);
  }
);

const updateTask = (state, { payload }) => {
  const task = payload;
  state.items = state.items.map((t) => (t.id === task.id ? task : t));
};

export const tasksSlice = createSlice({
  name: "tasks",
  initialState: {
    error: null,
    loading: false,
    items: [],
  },
  reducers: {
    setTasks: (state, { payload }) => {
      state.items = payload;
    },
  },
  extraReducers: (builder, x) => {
    builder.addCase(fetchTasks.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchTasks.fulfilled, (state, action) => {
      state.items = action.payload;
      state.loading = false;
    });
    builder.addCase(fetchTasks.rejected, (state, action) => {
      // TODO: Log error
      state.error = action.payload;
      state.loading = false;
    });

    // TODO: log errors of those tasks
    builder.addCase(markTaskAsDone.fulfilled, updateTask);

    builder.addCase(changeModule.fulfilled, updateTask);

    builder.addCase(restartTask.fulfilled, updateTask);

    builder.addCase(startTask.fulfilled, updateTask);

    builder.addCase(toggleChecklistItemOfTask.fulfilled, updateTask);

    builder.addCase(selectResult.fulfilled, updateTask);
  },
});

// SELECTORS

export const selectTasks = (state) => state.tasks.items || [];
export const selectTaskLength = (state) => (state.tasks.items || []).length;

// ACTIONS

export const { setTasks } = tasksSlice.actions;

export default tasksSlice.reducer;
